module.exports = __webpack_public_path__ + "img/star1.3d13a95a.png";